
import { Box, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import map from './picture_bg_mapa.svg';
import { fontLink, fontText, fontTitle, fullCenter } from '../../../base';
import auFlag from './Flags/icon_flag_austria.svg';
import beFlag from './Flags/icon_flag_belgium.svg';
import buFlag from './Flags/icon_flag_bulgaria.svg';
import crFlag from './Flags/icon_flag_croatia.svg';
import csFlag from './Flags/icon_flag_czech.svg';
import deFlag from './Flags/icon_flag_denmark.svg';
import esFlag from './Flags/icon_flag_estonia.svg';
import fiFlag from './Flags/icon_flag_finland.svg';
import frFlag from './Flags/icon_flag_france.svg';
import geFlag from './Flags/icon_flag_germany.svg';
import grFlag from './Flags/icon_flag_greece.svg';
import huFlag from './Flags/icon_flag_hungary.svg';
import irFlag from './Flags/icon_flag_ireland.svg';
import itFlag from './Flags/icon_flag_italy.svg';
import laFlag from './Flags/icon_flag_lativa.svg';
import liFlag from './Flags/icon_flag_lithuania.svg';
import luFlag from './Flags/icon_flag_luxemburg.svg';
import neFlag from './Flags/icon_flag_netherlands.svg';
import noFlag from './Flags/icon_flag_norway.svg';
import poFlag from './Flags/icon_flag_poland.svg';
import pgFlag from './Flags/icon_flag_portugal.svg';
import roFlag from './Flags/icon_flag_romania.svg';
import skFlag from './Flags/icon_flag_slovakia.svg';
import slFlag from './Flags/icon_flag_slovenia.svg';
import spFlag from './Flags/icon_flag_spain.svg';
import swFlag from './Flags/icon_flag_sweden.svg';
import { Motion } from '../../Motion';

import uaFlag from './Flags/icon_flag_ukraine.svg';
import ruFlag from './Flags/icon_flag_russia.svg';
import gbFlag from './Flags/icon_flag_unitedkingdom.svg';
import { Txt } from '../../../Routes/Localized';
import SubTitle from '../MainComponents/SubTitle';
import CountrySlider from '../../CountrySlider/CountrySlider';

import maFlag from './Flags/icon_flag_makedonie.svg';
import chFlag from './Flags/icon_flag_cerna_hora.svg';
import srFlag from './Flags/icon_flag_srbsko.svg';
import tuFlag from './Flags/icon_flag_turecko.svg';

import usFlag from './Flags/icon_flag_usa.svg';
import swiFlag from './Flags/icon_flag_sw.svg';



export const languagesMenu = [
    { code: "cs", label: "Čeština", sub: "Czech", flag: csFlag },
    { code: "uk", label: "Українська", sub: "Ukrainian", flag: uaFlag },
    { code: "en", label: "English", sub: "English", flag: gbFlag },
    { code: "de", label: "Deutsch", sub: "German", flag: geFlag },

    { code: "fr", label: "Français", sub: "French", flag: frFlag },
    { code: "es", label: "Español", sub: "Spanish", flag: spFlag },
    { code: "it", label: "Italiano", sub: "Italian", flag: itFlag },
    { code: "pl", label: "Polski", sub: "Polish", flag: poFlag },

    { code: "nl", label: "Nederlands", sub: "Dutch", flag: neFlag },
    { code: "pt", label: "Português", sub: "Portuguese", flag: pgFlag },
    { code: "el", label: "Ελληνικά", sub: "Greek", flag: grFlag },
    { code: "hu", label: "Magyar", sub: "Hungarian", flag: huFlag },

    { code: "et", label: "Eesti", sub: "Estonian", flag: esFlag },
    { code: "sv", label: "Svenska", sub: "Swedish", flag: swFlag },
    { code: "da", label: "Dansk", sub: "Danish", flag: deFlag },
    { code: "fi", label: "Suomi", sub: "Finnish", flag: fiFlag },

    { code: "bg", label: "Български", sub: "Bulgarian", flag: buFlag },
    { code: "hr", label: "Hrvatski", sub: "Croatian", flag: crFlag },
    { code: "ru", label: "Русский", sub: "Russian", flag: ruFlag },

];


export default function CountriesLayout({ sx = {} }) {
    const phone = useMediaQuery("(max-width:600px)");

    const flags = [
        { text: <Txt id={"170119"} />, flag: csFlag },
        { text: <Txt id={"170120"} />, flag: skFlag },
        { text: <Txt id={"170121"} />, flag: poFlag },
        { text: <Txt id={"170122"} />, flag: geFlag },
        { text: <Txt id={"170123"} />, flag: auFlag },
        { text: <Txt id={"170124"} />, flag: liFlag },
        { text: <Txt id={"170125"} />, flag: laFlag },
        { text: <Txt id={"170126"} />, flag: gbFlag },
        { text: <Txt id={"170127"} />, flag: beFlag },
        { text: <Txt id={"170142"} />, flag: neFlag },
        { text: <Txt id={"170143"} />, flag: ruFlag },
        { text: <Txt id={"170128"} />, flag: crFlag },
        { text: <Txt id={"170144"} />, flag: grFlag },
        { text: <Txt id={"170129"} />, flag: frFlag },
        { text: <Txt id={"170130"} />, flag: itFlag },
        { text: <Txt id={"170131"} />, flag: slFlag },
        { text: <Txt id={"170132"} />, flag: spFlag },
        { text: <Txt id={"170133"} />, flag: pgFlag },
        { text: <Txt id={"170134"} />, flag: maFlag },
        { text: <Txt id={"170135"} />, flag: chFlag },
        { text: <Txt id={"170136"} />, flag: srFlag },
        { text: <Txt id={"170137"} />, flag: tuFlag },
        { text: <Txt id={"170141"} />, flag: huFlag },
        { text: <Txt id={"170138"} />, flag: roFlag },
        { text: <Txt id={"170140"} />, flag: buFlag },
        { text: <Txt id={"170139"} />, flag: uaFlag },

        { text: <Txt id={"170147"} />, flag: swiFlag },
        { text: <Txt id={"170148"} />, flag: usFlag },
    ];


    return (
        <Box sx={{
            bgcolor: '#0165F4', borderRadius: '20px', backgroundImage: `url(${map})`,
            backgroundSize: "cover", // or "cover"
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat", py: { xs: '60px', sm: '160px' },
            ...sx
        }}>
            <Box sx={{ width: '100%', textAlign: 'center', ...fullCenter, flexDirection: 'column', px: '32px', overflow: 'hidden', }}>
                <SubTitle
                    title={<Txt id={"170145"} />}
                    subtitle={<Txt id={"170146"} />}
                    sxTitle={{ color: 'white' }}
                    sxSubtitle={{ color: 'white' }}
                    sx={{ py: '0px' }}
                />
                {phone ? <CountrySlider flags={flags} /> : <Box sx={{
                    display: 'flex', flexWrap: 'wrap', justifyContent: 'center',
                    gap: '16px', flexDirection: 'row', maxWidth: '950px', mt: '80px', userSelect: 'none'
                }}>
                    {flags.map((d, i) => <Motion key={"CLFlagMOT" + i} scale={1.02}>
                        <Box key={"CLFlag" + i} sx={{ borderRadius: '50px', bgcolor: 'white', ...fullCenter, flexDirection: 'row', height: '38px', px: '10px', py: '5px' }}>
                            <Box component={'img'} sx={{ width: '24px', height: '24px' }} src={d.flag} />
                            <Typography sx={{
                                "fontFamily": "Inter", fontWeight: 500,
                                ...fontLink, "verticalAlign": "middle", color: 'black', ml: '5px'
                            }}>{d.text}</Typography>
                        </Box>
                    </Motion>)}
                </Box>}

            </Box>
        </Box>
    )
}
